import { useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { EventService } from "@perxis-auto/shared/lib";
import "react-router";
import "@perxis-auto/shared";
import { APP } from "../../../shared/config/app.js";
import "../../../shared/config/env.js";
import { APP_EVENTS } from "../../../shared/config/events.js";
import "redux";
import { useAppDispatch } from "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import { selectors } from "../../../features/comparison/model/index.js";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import { useGetComparableVehicles } from "../../../features/comparison/lib/useGetComparableVehicles.js";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import "../../../shared/lib/logger/index.js";
import "@perxis-auto/shared/lib/lib/is/isObject";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
import { formatSpecifications } from "../lib/formatSpecifications.js";
import { actions } from "../../../features/comparison/model/slice.js";
const useContainer = (item) => {
  const { schemes, ...props } = useMergedConstructorItemProps(item, GET_DEFAULT_CONTAINER_PROPS);
  const { t } = useTranslation(APP.name);
  const eventService = EventService.getInstance();
  const {
    preparedData: { selectedComparableVehicles = [] }
  } = useGetComparableVehicles();
  const dispatch = useAppDispatch();
  const isShowDifference = useAppSelector(selectors.selectIsShowDifference);
  const comparedSpecifications = useMemo(() => {
    return formatSpecifications(
      {
        vehicleItems: selectedComparableVehicles,
        schemes
      },
      { onlyDifferences: isShowDifference }
    );
  }, [isShowDifference, schemes, selectedComparableVehicles]);
  const onShowDifferenceChange = useCallback(() => {
    const selectedSpecifications = formatSpecifications(
      {
        vehicleItems: selectedComparableVehicles,
        schemes
      },
      { onlyDifferences: !isShowDifference }
    );
    eventService.sendEvent(APP_EVENTS.ComparisonViewChanged, {
      previous: comparedSpecifications,
      selected: selectedSpecifications
    });
    dispatch(actions.showDifferenceToggle());
  }, [comparedSpecifications, dispatch, eventService, isShowDifference, schemes, selectedComparableVehicles]);
  return {
    ...props,
    isShowDifference,
    items: comparedSpecifications,
    hasVehicles: !!selectedComparableVehicles.length,
    onShowDifferenceChange,
    t
  };
};
export {
  useContainer
};
